import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "../styles/NammaPass.css";
import { SvgMeshGrid, SvgCornerOrn, SvgCardLines, SvgSectionDivider } from "./SvgDecorations";

const blogPosts = [
  {
    id: 4,
    category: "METRO • DIGITAL MOBILITY",
    title: "Namma Metro Mobile QR Code Passes, Digital Smart Metro Pass and Unlimited Travel with Namma Pass",
    subtitle:
      "₹199 Unlimited Plan, up to 20% cashback, carbon credits rewards, and smart metro ticket booking. Daily travel on Namma Metro is now smarter, faster, and more rewarding.",
    readTime: "7 min read",
    impact: "Urban Mobility",
    route: "/blog/namma-pass-digital-metro-pass",
    gradient: "from-green-600/20 to-teal-600/20",
    accent: "#8cff2e",
  },
];

const Blogs: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleClick = (route: string) => {
    if (route.startsWith("http")) window.open(route, "_blank");
    else navigate(route);
  };

  return (
    <>
      <div className="np-root" style={{ paddingTop: 76 }}>

        {/* bg canvas */}
        <div className="bg-canvas" />

        {/* ambient rings */}
        <div style={{ position:"fixed", inset:0, pointerEvents:"none", zIndex:1, overflow:"hidden" }}>
          <div className="np-orbit-ring np-orbit-ring-1" style={{ left:"50%", top:"30%" }} />
          <div className="np-orbit-ring np-orbit-ring-2" style={{ left:"50%", top:"30%" }} />
        </div>

        {/* ── Header ── */}
        <header className="blogs-header" style={{ position: "relative" }}>
          <SvgMeshGrid opacity={0.05} />
          <SvgCornerOrn position="tl" />
          <SvgCornerOrn position="tr" />
          <div className="blogs-header-inner" style={{ position: "relative", zIndex: 2 }}>
            <div className="np-section-label" style={{ margin:"0 auto 20px" }}>Namma Pass Blog</div>
            <h1 className="blogs-main-title">
              Stories from the{" "}
              <span className="blogs-title-accent">Commute</span>
            </h1>
            <p className="blogs-main-sub">
              Tips, updates, and deep-dives on smarter metro travel in Bengaluru - how Namma Pass
              is making daily commutes faster, greener, and more rewarding with every tap.
            </p>
          </div>
          <div style={{ position: "absolute", bottom: -1, left: 0, right: 0, zIndex: 3 }}>
            <SvgSectionDivider />
          </div>
        </header>

        {/* ── Posts ── */}
        <main className="blogs-main">
          {blogPosts.map((post, i) => (
            <article
              key={post.id}
              className="blog-card"
              onClick={() => handleClick(post.route)}
              style={{ animationDelay: `${i * 0.12}s` }}
              itemScope
              itemType="https://schema.org/BlogPosting"
            >
              {/* top accent line */}
              <div className="blog-card-line" style={{ background: `linear-gradient(90deg, ${post.accent}, transparent)` }} />
              {/* SVG corner decoration */}
              <SvgCardLines color={post.accent} />

              <div className="blog-card-body">
                {/* category */}
                <div className="blog-category" style={{ color: post.accent, borderColor: `${post.accent}33`, background: `${post.accent}10` }}>
                  {post.category}
                </div>

                {/* title */}
                <h2 className="blog-title" itemProp="headline">{post.title}</h2>

                {/* subtitle */}
                <p className="blog-sub" itemProp="description">{post.subtitle}</p>

                {/* meta + cta */}
                <div className="blog-footer">
                  <div className="blog-meta">
                    <span>⏱ {post.readTime}</span>
                    <span>🌍 {post.impact}</span>
                  </div>
                  <div className="blog-cta" style={{ borderColor: `${post.accent}44`, color: post.accent }}>
                    Read article <span className="blog-arrow">→</span>
                  </div>
                </div>
              </div>
            </article>
          ))}
        </main>

      </div>
    </>
  );
};

export default Blogs;
